import { render, staticRenderFns } from "./LoadBook.vue?vue&type=template&id=954db430&scoped=true&"
import script from "./LoadBook.vue?vue&type=script&lang=js&"
export * from "./LoadBook.vue?vue&type=script&lang=js&"
import style0 from "./LoadBook.vue?vue&type=style&index=0&id=954db430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954db430",
  null
  
)

export default component.exports